/* eslint-disable import/prefer-default-export */

import http from '../core/HttpClient';
import { insertParams } from '../core/actionHelpers';
import urls from '../constants/urls';

import {
  SET_DEVICE_COMMAND_VALUE,
  UPDATE_DEVICE_COMMAND_VALUE,
  EDIT_DEVICE,
  SAVE_DEVICE_DATA,
  SAVE_INSTALLATION_DATA,
  RESET_CONNECTED_DEVICE,
  CLEAR_DEVICE_USER_DATA,
  GET_DEVICE_DETAILS,
  REMOVE_OWNERSHIP,
  REMOVE_PROTECTED_INSTALLATION,
  ADD_OWNERSHIP,
  GET_OWNERSHIP,
  SET_OWNERSHIP_EMAILS,
  SET_OWNERSHIP_SEARCH_QUERY,
  GET_COMMON_DEVICE_INFO,
  GET_COMMON_LIVE_DEVICE_DATA,
  SET_COMMON_DEVICE_SCREEN,
  SET_COMMON_POPUP_NOTAVAILABLE,
  SET_COMMON_USER_DATA,
  SET_COMMON_SCREEN_NEXT_PREVIOUS_PAGE,
  SET_COMMON_LEFT_ARROW,
  SET_COMMON_RIGHT_ARROW,
  SET_COMMON_POWER_POPUP,
  SET_COMMON_WARNING_POPUP,
  SET_COMMON_ALARM_POPUP,
  SET_POWER_DOWN,
  SET_CLEAN_WARNING,
  SET_CLEAN_ALARM,
  CLEAR_WORK_HISTORY_PAGE,
  CLEAR_ERROR_HISTORY_PAGE
} from '../constants';

export function setDeviceCommandValue(deviceid, command, value) {
  return {
    type: SET_DEVICE_COMMAND_VALUE,
    promise: http.post(`${urls.API2_URL}/${deviceid}/set`, {
      deviceid,
      command,
      value,
    }),
  };
}

export function updateDeviceCommandValue(deviceid, command, value, devicetype) {
  return {
    type: UPDATE_DEVICE_COMMAND_VALUE,
    devicetype,
    command,
    value
  };
}

export function clearWorkHistoryPage(devicetype) {
  return {
    type: CLEAR_WORK_HISTORY_PAGE,
    devicetype,
  };
}
export function clearErrorHistoryPage(devicetype) {
  return {
    type: CLEAR_ERROR_HISTORY_PAGE,
    devicetype,
  };
}

export function setScreenNextPreviousPage(screen, value, devicetype) {
  return {
    type: SET_COMMON_SCREEN_NEXT_PREVIOUS_PAGE,
    screen,
    value,
    devicetype,
  };
}

export function setScreen(screen, devicetype) {
  return {
    type: SET_COMMON_DEVICE_SCREEN,
    screen,
    devicetype,
  };
}

export function setUserData(command, value, devicetype) {
  return {
    type: SET_COMMON_USER_DATA,
    command,
    value,
    devicetype,
  };
}

export function setPopupNotAvailable(value, devicetype) {
  return {
    type: SET_COMMON_POPUP_NOTAVAILABLE,
    value,
    devicetype,
  };
}


export function getLiveFakeDeviceData(diff, devicetype) {
  return {
    type: 'GET_FAKE_COMMON_LIVE_DEVICE_DATA',
    devicetype,
    diff,
  };
}

export function clearDeviceUserData(devicetype) {
  return {
    type: CLEAR_DEVICE_USER_DATA,
    devicetype,
  };
}

/* eslint-disable import/prefer-default-export */

export function getDeviceInfo(deviceId, devicetype) {
  return {
    type: GET_COMMON_DEVICE_INFO,
    devicetype,
    promise: http.get(`${urls.API2_URL}/${deviceId}`),
  };
}

export function getDeviceDetail(deviceid){
  return {
    type: GET_DEVICE_DETAILS,
    devicetype,
    promise: http.get(`${urls.API2_URL}/${deviceId}/details`),
  };
}

export function getLiveDeviceData(deviceId, devicetype) {
  return {
    type: GET_COMMON_LIVE_DEVICE_DATA,
    devicetype,
    promise: http.get(`${urls.API2_URL}/${deviceId}/live`),
  };
}

export function editDevice(deviceid) {
  return {
    type: EDIT_DEVICE,
    promise: http.get(`${urls.API2_URL}/${deviceid}/edit`),
  };
}

export function saveDeviceData(deviceid, data) {
  return {
    type: SAVE_DEVICE_DATA,
    promise: http.post(`${urls.API2_URL}/${deviceid}/edit`, data),
  };
}

export function saveInstallationData(data) {
  return {
    type: SAVE_INSTALLATION_DATA,
    promise: http.post(`${urls.API2_URL}/installation`, data),
  };
}

export function resetConnectedDevice(devicetype) {
  return {
    type: RESET_CONNECTED_DEVICE,
    devicetype,
  };
}

export function removeOwnership(deviceid, action) {
  return {
    type: REMOVE_OWNERSHIP,
    promise: http.delete(`${urls.API2_URL}/${deviceid}/ownership`, { action }),
  };
}

export function removeProtectedInstallation(installation_id, serial) {
  return {
    type: REMOVE_PROTECTED_INSTALLATION,
    promise: http.delete(`${urls.API2_URL}/installation/${installation_id}`, { serial }),
  };
}

export function getOwnership(deviceid, userType, params) {
  const url = insertParams(`${urls.API2_URL}/${deviceid}/ownership/role/${userType}`, params);
  return {
    type: GET_OWNERSHIP,
    promise: http.get(url),
  };
}

export function setOwnershipEmails(deviceid, alarms) {
  return {
    type: SET_OWNERSHIP_EMAILS,
    promise: http.post(`${urls.API2_URL}/${deviceid}/ownership/email/${alarms}`, {}),
  };
}

export function saveOwnership(deviceid, data) {
  return {
    type: ADD_OWNERSHIP,
    promise: http.post(
      `${urls.API2_URL}/${deviceid}/ownership`,
      data
    ),
  };
}

export function setSearchQuery(searchQuery) {
  return {
    type: SET_OWNERSHIP_SEARCH_QUERY,
    searchQuery,
  };
}

export function setLeftArrow(value, devicetype) {
  return {
    type: SET_COMMON_LEFT_ARROW,
    value,
    devicetype,
  };
}

export function setRightArrow(value, devicetype) {
  return {
    type: SET_COMMON_RIGHT_ARROW,
    value,
    devicetype,
  };
}

export function setPowerPopup(value, devicetype) {
  return {
    type: SET_COMMON_POWER_POPUP,
    value,
    devicetype,
  };
}

export function setWarningPopup(value, devicetype) {
  return {
    type: SET_COMMON_WARNING_POPUP,
    value,
    devicetype,
  };
}

export function setAlarmPopup(value, devicetype) {
  return {
    type: SET_COMMON_ALARM_POPUP,
    value,
    devicetype,
  };
}

export function setPowerDown(devicetype) {
  return {
    type: SET_POWER_DOWN,
    devicetype,
  };
}

export function clearWarning(devicetype) {
  return {
    type: SET_CLEAN_WARNING,
    devicetype,
  };
}

export function clearAlarm(devicetype) {
  return {
    type: SET_CLEAN_ALARM,
    devicetype,
  };
}



// WEBPACK FOOTER //
// ./src/actions/device.js